import { useEffect } from "react";
import { Link, useLocation } from "react-router";
import { MobileCategoriesMenu } from "./MobileCategoriesMenu";
import { observer } from "mobx-react-lite";
import appStore from "../stores/appStore";
import catalogIcon from "../assets/catalog_icon.svg";
const FooterMobile = () => {
  useEffect(() => {}, []);

  const location = useLocation();

  const labelStyle = "font-sewmibold text-[12px] tracking-[-2%] leading-[150%]";

  return (
    <footer className="!bg-[#FFFFFFBF] backdrop-blur-lg border-t border-[#C6C6C8BF] !text-[#707070] flex sticky bottom-0 w-[100vw] z-10">
      <nav className="flex flex-row gap-[9%] !w-full items-center justify-center overflow-hidden  !text-[13px] font-semibold">
        <div className="">
          <div className="whitespace-nowrap w-[40px] flex flex-col items-center">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.93896 23.6069C6.93945 23.6069 5.87744 22.5376 5.87744 20.5234V6.20459C5.87744 4.19043 6.93945 3.12109 8.93896 3.12109H19.0464C21.0459 3.12109 22.1079 4.18311 22.1079 6.20459V16.4878C21.6172 15.8799 20.98 15.4038 20.2549 15.1255V6.35107C20.2549 5.4502 19.7715 4.9668 18.8633 4.9668H9.12207C8.18457 4.9668 7.73047 5.46484 7.73047 6.35107V20.377C7.73047 21.2632 8.18457 21.7539 9.12207 21.7539H13.6777C13.9634 22.479 14.4395 23.1162 15.062 23.6069H8.93896ZM10.5356 8.80469C10.2061 8.80469 9.96436 8.54834 9.96436 8.2334C9.96436 7.91846 10.2061 7.67676 10.5356 7.67676H17.457C17.7793 7.67676 18.021 7.91846 18.021 8.2334C18.021 8.54834 17.7793 8.80469 17.457 8.80469H10.5356ZM10.5356 12.0127C10.2061 12.0127 9.96436 11.7637 9.96436 11.4414C9.96436 11.1338 10.2061 10.8921 10.5356 10.8921H17.457C17.7793 10.8921 18.021 11.1338 18.021 11.4414C18.021 11.7637 17.7793 12.0127 17.457 12.0127H10.5356ZM18.043 23.3359C15.9482 23.3359 14.2271 21.6147 14.2271 19.5127C14.2271 17.418 15.9482 15.6895 18.043 15.6895C20.145 15.6895 21.8662 17.418 21.8662 19.5127C21.8662 20.2671 21.6392 20.9775 21.2583 21.5708L23.4482 23.7754C23.624 23.9512 23.7266 24.1636 23.7266 24.3906C23.7266 24.896 23.3677 25.2622 22.8843 25.2622C22.6133 25.2622 22.3936 25.1597 22.1958 24.9692L20.0059 22.7866C19.4346 23.1382 18.7607 23.3359 18.043 23.3359ZM18.0503 22.0029C19.4126 22.0029 20.5332 20.8823 20.5332 19.5054C20.5332 18.1504 19.4126 17.0298 18.0503 17.0298C16.688 17.0298 15.5601 18.1504 15.5601 19.5054C15.5601 20.875 16.688 22.0029 18.0503 22.0029Z"
                fill="#707070"
              />
            </svg>

            <MobileCategoriesMenu
              categories={appStore.categories}
            ></MobileCategoriesMenu>
          </div>
        </div>
        <Link
          to={"/profile/favorites"}
          className={
            location.pathname == "/profile/favorites"
              ? "text-[#383181]"
              : "text-[#707070]"
          }
        >
          <div className="whitespace-nowrap w-[40px] flex flex-col items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M14 22.8086C13.751 22.8086 13.3921 22.6182 13.0845 22.4204C7.87695 19.0293 4.45654 15.0669 4.45654 11.0532C4.45654 7.57422 6.87354 5.16455 9.88379 5.16455C11.7441 5.16455 13.1797 6.20459 14 7.74268C14.8276 6.19727 16.2632 5.16455 18.1235 5.16455C21.1338 5.16455 23.5435 7.57422 23.5435 11.0532C23.5435 15.0669 20.1304 19.0293 14.9155 22.4204C14.6079 22.6182 14.249 22.8086 14 22.8086Z"
                fill={
                  location.pathname == "/profile/favorites"
                    ? "#383181"
                    : "#707070"
                }
              />
            </svg>
            <span className={labelStyle}>Избранное</span>
          </div>
        </Link>
        <Link
          to={"/"}
          className={
            location.pathname == "/" ? "text-[#383181]" : "text-[#707070]"
          }
        >
          <div className="whitespace-nowrap w-[40px] flex flex-col items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M3.46045 13.9609C2.86719 13.9609 2.50098 13.5581 2.50098 13.0674C2.50098 12.7964 2.62549 12.5181 2.87451 12.313L12.6523 4.10986C13.0698 3.75098 13.5386 3.58252 14 3.58252C14.4688 3.58252 14.9302 3.75098 15.3477 4.10986L19.9912 8.00635V6.33643C19.9912 5.93359 20.2622 5.67725 20.665 5.67725H21.9907C22.3936 5.67725 22.6499 5.93359 22.6499 6.33643V10.2329L25.1255 12.313C25.3745 12.5181 25.499 12.7964 25.499 13.0674C25.499 13.5581 25.1328 13.9609 24.5469 13.9609C24.2612 13.9609 24.0049 13.8145 23.7852 13.624L14.4468 5.79443C14.3003 5.66992 14.1465 5.61133 14 5.61133C13.8535 5.61133 13.6997 5.66992 13.5605 5.79443L4.21484 13.624C3.99512 13.8145 3.73877 13.9609 3.46045 13.9609ZM5.51123 21.6953V14.3418L13.3994 7.72803C13.7729 7.41309 14.2124 7.40576 14.5933 7.72803L22.4814 14.3491V21.6953C22.4814 23.0283 21.6318 23.8413 20.2549 23.8413H7.73779C6.36084 23.8413 5.51123 23.0283 5.51123 21.6953ZM11.4292 22.0469H16.5781V16.5684C16.5781 16.1436 16.2998 15.8652 15.8677 15.8652H12.1396C11.7075 15.8652 11.4292 16.1436 11.4292 16.5684V22.0469Z"
                fill={location.pathname == "/" ? "#383181" : "#707070"}
              />
            </svg>
            <span className={labelStyle}>Главная</span>
          </div>
        </Link>
        <Link
          to={"cart"}
          className={
            location.pathname == "/cart" ? "text-[#383181]" : "text-[#707070]"
          }
        >
          <div className="whitespace-nowrap w-[40px] flex flex-col items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M8.54346 23.4092C6.5293 23.4092 5.45996 22.3545 5.45996 20.3477V10.5405C5.45996 8.53369 6.5293 7.479 8.54346 7.479H10.0962C10.2939 5.48682 11.8979 4.01465 14 4.01465C16.1021 4.01465 17.7061 5.48682 17.8965 7.479H19.4492C21.4707 7.479 22.54 8.54102 22.54 10.5405V20.3477C22.54 22.3472 21.4707 23.4092 19.6323 23.4092H8.54346ZM14 5.62598C12.8721 5.62598 12.0444 6.37305 11.876 7.479H16.124C15.9482 6.37305 15.1279 5.62598 14 5.62598Z"
                fill={location.pathname == "/cart" ? "#383181" : "#707070"}
              />
            </svg>
            <span className={labelStyle}>Корзина</span>
          </div>
        </Link>
        <Link
          to={"profile"}
          className={
            location.pathname == "/profile"
              ? "text-[#383181]"
              : "text-[#707070]"
          }
        >
          <div className="whitespace-nowrap w-[40px] flex flex-col items-center">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M11.9912 24.3525C10.708 24.3525 9.4834 24.1533 8.31738 23.7549C7.15137 23.3623 6.0791 22.8057 5.10059 22.085C4.12793 21.3701 3.28125 20.5234 2.56055 19.5449C1.8457 18.5664 1.28906 17.4941 0.890625 16.3281C0.492188 15.1621 0.292969 13.9375 0.292969 12.6543C0.292969 11.3711 0.489258 10.1465 0.881836 8.98047C1.28027 7.81445 1.83984 6.74512 2.56055 5.77246C3.28125 4.79395 4.12793 3.94434 5.10059 3.22363C6.07324 2.50293 7.14258 1.94629 8.30859 1.55371C9.47461 1.15527 10.6992 0.956055 11.9824 0.956055C13.2656 0.956055 14.4902 1.15527 15.6562 1.55371C16.8281 1.94629 17.9004 2.50293 18.873 3.22363C19.8516 3.94434 20.7012 4.79395 21.4219 5.77246C22.1426 6.74512 22.7021 7.81445 23.1006 8.98047C23.499 10.1465 23.6982 11.3711 23.6982 12.6543C23.6982 13.9375 23.499 15.1621 23.1006 16.3281C22.7021 17.4941 22.1426 18.5664 21.4219 19.5449C20.7012 20.5234 19.8516 21.3701 18.873 22.085C17.9004 22.8057 16.8311 23.3623 15.665 23.7549C14.499 24.1533 13.2744 24.3525 11.9912 24.3525ZM11.9912 22.0762C13.04 22.0762 14.0332 21.915 14.9707 21.5928C15.9141 21.2764 16.7783 20.8311 17.5635 20.2568C18.3486 19.6826 19.0283 19.0029 19.6025 18.2178C20.1768 17.4326 20.6191 16.5713 20.9297 15.6338C21.2461 14.6904 21.4043 13.6973 21.4043 12.6543C21.4043 11.6113 21.2461 10.6182 20.9297 9.6748C20.6191 8.73145 20.1738 7.87012 19.5938 7.09082C19.0195 6.30566 18.3398 5.62598 17.5547 5.05176C16.7695 4.47754 15.9053 4.03223 14.9619 3.71582C14.0244 3.39941 13.0312 3.24121 11.9824 3.24121C10.9395 3.24121 9.94629 3.39941 9.00293 3.71582C8.06543 4.03223 7.2041 4.47754 6.41895 5.05176C5.63965 5.62598 4.96289 6.30566 4.38867 7.09082C3.81445 7.87012 3.36914 8.73145 3.05273 9.6748C2.73633 10.6182 2.57812 11.6113 2.57812 12.6543C2.57812 13.6973 2.73633 14.6904 3.05273 15.6338C3.36914 16.5713 3.81445 17.4326 4.38867 18.2178C4.96875 19.0029 5.64844 19.6826 6.42773 20.2568C7.21289 20.8311 8.07422 21.2764 9.01172 21.5928C9.95508 21.915 10.9482 22.0762 11.9912 22.0762ZM19.4531 20.1162C18.7266 20.7666 17.9268 21.3145 17.0537 21.7598C16.1865 22.2109 15.3135 22.5508 14.4346 22.7793C13.5615 23.0078 12.7471 23.1221 11.9912 23.1221C11.2471 23.1221 10.4326 23.0049 9.54785 22.7705C8.66309 22.542 7.78418 22.2021 6.91113 21.751C6.04395 21.3057 5.25 20.7607 4.5293 20.1162L4.56445 19.8965C4.76953 19.4863 5.08887 19.085 5.52246 18.6924C5.96191 18.2939 6.50098 17.9365 7.13965 17.6201C7.78418 17.2979 8.51367 17.04 9.32812 16.8467C10.1426 16.6533 11.0303 16.5566 11.9912 16.5566C12.9521 16.5566 13.8398 16.6533 14.6543 16.8467C15.4746 17.04 16.2041 17.2979 16.8428 17.6201C17.4814 17.9424 18.0205 18.3027 18.46 18.7012C18.8994 19.0938 19.2188 19.498 19.418 19.9141L19.4531 20.1162ZM11.9912 14.7197C11.2588 14.7139 10.5967 14.5234 10.0049 14.1484C9.41895 13.7676 8.95312 13.2549 8.60742 12.6104C8.26172 11.9658 8.08887 11.2363 8.08887 10.4219C8.08301 9.66602 8.25293 8.96875 8.59863 8.33008C8.9502 7.69141 9.42188 7.18164 10.0137 6.80078C10.6055 6.41406 11.2646 6.2207 11.9912 6.2207C12.7178 6.2207 13.374 6.41406 13.96 6.80078C14.5518 7.18164 15.0205 7.69141 15.3662 8.33008C15.7178 8.96875 15.8936 9.66602 15.8936 10.4219C15.8936 11.2363 15.7207 11.9688 15.375 12.6191C15.0293 13.2637 14.5605 13.7764 13.9688 14.1572C13.3828 14.5381 12.7236 14.7256 11.9912 14.7197Z"
                fill={location.pathname == "/profile" ? "#383181" : "#707070"}

                //   style="fill:#707070;fill:color(display-p3 0.4392 0.4392 0.4392);fill-opacity:1;"
              />
            </svg> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M13.9927 23.4604C8.60938 23.4604 4.24414 19.0952 4.24414 13.7119C4.24414 8.32861 8.60938 3.95605 13.9927 3.95605C19.3833 3.95605 23.7485 8.32861 23.7485 13.7119C23.7485 19.0952 19.3833 23.4604 13.9927 23.4604ZM13.9927 16.9712C16.666 16.9712 18.7241 17.9526 19.7202 19.0806C21.0386 17.6743 21.8442 15.792 21.8442 13.7119C21.8442 9.36865 18.3359 5.86035 13.9927 5.86035C9.65674 5.86035 6.14844 9.36865 6.14844 13.7119C6.14844 15.7847 6.9541 17.6743 8.27246 19.0806C9.26855 17.9526 11.3267 16.9712 13.9927 16.9712ZM13.9927 15.4331C12.1616 15.4185 10.748 13.873 10.7407 11.8516C10.7334 9.95459 12.1763 8.35059 13.9927 8.35059C15.8091 8.35059 17.2446 9.95459 17.2446 11.8516C17.2446 13.873 15.8237 15.4404 13.9927 15.4331Z"
                fill={location.pathname == "/profile" ? "#383181" : "#707070"}
              />
            </svg>
            <span className={labelStyle}>{appStore.user?.name || "Аккаунт"}</span>
          </div>
        </Link>
      </nav>
    </footer>
  );
};

export default observer(FooterMobile);
